import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const HeardIslandandMcDonaldIslands: Country = {
    identifier: "HeardIslandandMcDonaldIslands",
    name: "Heard Island and McDonald Islands",
    countryCode: "HM",
    group: CountryGroup.OCEANIA,
    isUNMember: false,
    flag: "🇭🇲",
    svgPath: "m 681.75475,638.7484 -0.335,0.222 -0.345,-0.002 -0.147,-0.174 -0.215,-0.545 -0.143,-0.039 -0.089,-0.15 -0.007,-0.063 0.152,-0.044 0.232,0.156 0.555,0.126 0.408,0.299 0.3,0.101 -0.12,0.08 z",
}
